/**
 * BoQ unit options for Einheit (unit) column. GAEB/cosuno-style.
 * Value is the tag used in data/API; label can be same or i18n key.
 */
export const BOQ_UNITS = [
	"m³",
	"TS",
	"kpl",
	"d",
	"h",
	"kg",
	"lfm",
	"psch",
	"m",
	"Mt",
	"Stk",
	"StWo",
	"m²",
	"t",
	"Wo",
];
